import React, {useEffect, useState} from "react";
import {
    Modal,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Select,
    SelectItem
} from "@nextui-org/react";
import {useVending} from "./VendingProvider";
import {ShowImage} from "./ShowQR";
import {PayCompleted} from "./PayCompleted";
import Lottie from "lottie-react";
import loading from '../../assets/loading.json'
import Cookies from "universal-cookie";
import {CloseDoor} from "./CloseDoor";
import {toast, Toaster} from "sonner";

export default function Dialog() {
    const {
        data, onOpenChange, isOpen,
        setCart, cart, status,
        Reseting, results, openQR, idMachine
    } = useVending();
    const [amount, setAmount] = useState(1);
    const [quick, setQuick] = useState(false);

    const render = {
        "loading":
            <ModalContent>
                <ModalBody>
                    <div className="loading-container">
                        <Lottie animationData={loading}/>
                    </div>
                </ModalBody>
            </ModalContent>
        ,
        "start": <ShowItem data={data} quickBuy={QuickBuy} addItem={AddItem} setAmount={setAmount} cart={cart} />,
        "showQR": <ShowImage/>,
        "result": <PayCompleted data={results} Reseting={Reseting}/>,
        "close_door": <CloseDoor Reseting={Reseting}/>,
    }

    useEffect(() => {
        if (quick && cart.length > 0) {
            openQR();
        }
    }, [quick, cart]);

    function AddItem() {
        const cookies = new Cookies();
        const newItem = {
            idproduct: data.idproduct,
            name: data.name,
            amount: amount,
            price: data.price,
            idmachine: idMachine
        }

        setCart([...cart, newItem])
        cookies.set('cart', [...cart, newItem]);
        onOpenChange(false);
        setQuick(false);
        toast.success("Item añadido al carrito. 🛒");
    }


    function QuickBuy() {
        const newItem = {
            idproduct: data.idproduct,
            name: data.name,
            amount: amount,
            price: data.price,
            idmachine: idMachine
        }

        setCart([...cart, newItem]);
        setQuick(true);
        setAmount(1);
    }

    return (
        <>
            <Modal
                backdrop="blur"
                isOpen={isOpen}
                onOpenChange={onOpenChange}
                radius="lg"
                hideCloseButton={true}
                isDismissable={false}
                classNames={{
                    backdrop: "bg-gradient-to-t from-zinc-900 to-zinc-900/10 backdrop-opacity-20"
                }}
            >
                {
                    render[status]
                }


            </Modal>
        </>
    );
}

const ShowItem = ({data, quickBuy, addItem, setAmount, cart}) => {
    const [cant, setCant] = useState(1);

    function OnSetAmount(e) {
        const c = parseInt(e.target.value) + 1;
        setCant(c)
        setAmount(c);
    }

    function QuickBuy() {
        quickBuy();
    }

    return (
        <>
            <Toaster richColor />
            <ModalContent>
                {(onClose) => (
                    <>
                        <ModalHeader className="flex flex-col gap-1 text-3xl">{data.name}</ModalHeader>
                        <ModalBody>
                            <table className="text-xl">
                                <tbody>
                                <tr>
                                    <td>Cantidad:</td>
                                    <td className="text-center">
                                        <Select
                                            className="max-w-xs"
                                            defaultSelectedKeys={["0"]}
                                            aria-label="Cantidad"
                                            onChange={OnSetAmount}
                                            size="lg"
                                            disallowEmptySelection={true}
                                        >
                                            {data.amount.map((item, index) => (
                                                <SelectItem key={index} textValue={item}>
                                                   <span className="text-2xl">{item}</span>
                                                </SelectItem>
                                            ))}
                                        </Select>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Precio unitario:</td>
                                    <td className="text-right"><b>Gs. {data.price}</b></td>
                                </tr>
                                <tr className="text-2xl">
                                    <td>Total:</td>
                                    <td className="text-right"><b className="text-success">Gs. {data.price * cant}</b>
                                    </td>
                                </tr>
                                </tbody>
                            </table>

                        </ModalBody>
                        <hr className="top-3 bottom-2 border-warning"/>
                        <ModalFooter className="flex flex-col gap-3 bottom-2">
                            <Button className={`bg-success ${cart.length > 0 && "hidden"}`} onPress={QuickBuy} isDisabled={cart.length > 0} >
                                Comprar rapida
                            </Button>
                            <Button className="bg-warning" onPress={addItem}>
                                Añadir al carrito
                            </Button>
                            <Button className="bg-danger" onPress={onClose}>
                                Cancelar
                            </Button>

                        </ModalFooter>
                    </>
                )}

            </ModalContent>
        </>

    )
}
